export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8346.a1ecfd50.jpg";